// The background resolvers keep colours as authored and React writes style values verbatim, so only forms that cannot end
// the declaration get through. The CMS writes a colour with opacity as `color-mix(in srgb, <colour> N%, transparent)`
// (b2b-apps codecs/colour-opacity.ts).
const PLAIN_COLOUR =
  "#(?:[0-9a-f]{3,4}|[0-9a-f]{6}|[0-9a-f]{8})|(?:rgba?|hsla?)\\([\\w\\s.,%/+-]*\\)|var\\(--[\\w-]+\\)";
const CSS_COLOUR = new RegExp(
  `^(?:${PLAIN_COLOUR}|color-mix\\(in srgb,\\s*(?:${PLAIN_COLOUR})\\s+(?:100|\\d{1,2}(?:\\.\\d+)?)%,\\s*transparent\\))$`,
  "i",
);

export function isCssColour(value?: string): value is string {
  return value !== undefined && CSS_COLOUR.test(value);
}
